import { token } from '@atlaskit/tokens';
import { css } from '@emotion/react';
import React, { memo } from 'react';

import { Icon } from '@components/shared/Icon';

import { SkeletonLoader } from '@components/learning/LearningSidebar/children/SkeletonLoader';

export const LessonsSkeletonLoader: React.FC = memo(() => (
  <>
    {[...Array(4)].map((_, index) => (
      <div css={lessonCardHeaderStyles} key={index}>
        <div css={lessonExpanderStyles}>
          <Icon type="chevron-right" color={token('color.icon')} />
        </div>
        <div css={skeletonLoaderBarStyles}>
          <SkeletonLoader />
          <div css={skeletonTimeLoaderBarStyles}>
            <SkeletonLoader />
          </div>
        </div>
      </div>
    ))}
  </>
));

const lessonCardHeaderStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  paddingTop: token('space.100'),
  paddingBottom: token('space.100'),
  paddingLeft: token('space.250'),
  paddingRight: token('space.100'),
});

const lessonExpanderStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '4px',
});

const skeletonTimeLoaderBarStyles = css({
  width: '50px',
  height: '20px',
  marginLeft: token('space.300'),
});

const skeletonLoaderBarStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '20px',
  marginLeft: token('space.025'),
});
